import(/* webpackMode: "eager" */ "/vercel/path0/src/app/islamic-calendar/page.tsx");
